import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import SiteGate from "@/components/SiteGate";
import ChatPage from "@/pages/ChatPage";
import FinancialAdvisorPage from "@/pages/FinancialAdvisorPage";
import PlanReviewPage from "@/pages/PlanReviewPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

// Hala Control Center - Premium Admin Panel
import AdminLayout from "@/components/admin/AdminLayout";
import DashboardPage from "@/pages/admin/DashboardPage";
import CatalogPageV2 from "@/pages/admin/CatalogPageV2";
import MappingPage from "@/pages/admin/MappingPage";
import RecommendationEnginePage from "@/pages/admin/RecommendationEnginePage";
import ResourcesPage from "@/pages/admin/ResourcesPage";
import SessionsPage from "@/pages/admin/SessionsPage";
import SessionsPageV2 from "@/pages/admin/SessionsPageV2";
import SessionAnalysisPage from "@/pages/admin/SessionAnalysisPage";
import LearningCenterPage from "@/pages/admin/LearningCenterPage";
import AIAnalyticsPage from "@/pages/admin/AIAnalyticsPage";
import FinancialAdvisorSettingsPage from "@/pages/admin/FinancialAdvisorSettingsPage";
import LeadsPage from "@/pages/admin/LeadsPage";
import IssuesPage from "@/pages/admin/IssuesPage";
import AnalyticsPage from "@/pages/admin/AnalyticsPage";
import UsersPage from "@/pages/admin/UsersPage";

// CRM - Administrative Structure (Admin Panel)
import CRMUsersPage from "@/pages/admin/CRMUsersPage";
import CRMGroupsPage from "@/pages/admin/CRMGroupsPage";
import CRMRolesPage from "@/pages/admin/CRMRolesPage";

// CRM - Operational Portal
import CRMLoginPage from "@/pages/crm/CRMLoginPage";
import CRMLayout from "@/pages/crm/CRMLayout";
import CRMDashboardPage from "@/pages/crm/CRMDashboardPage";
import CRMSupervisorPage from "@/pages/crm/CRMSupervisorPage";
import CRMRequestsPage from "@/pages/crm/CRMRequestsPage";
import CRMPoolPage from "@/pages/crm/CRMPoolPage";
import CRMMyRequestsPage from "@/pages/crm/CRMMyRequestsPage";
import CRMRequestDetailsPage from "@/pages/crm/CRMRequestDetailsPage";
import CRMAdminUsersPage from "@/pages/crm/CRMAdminUsersPage";
import CRMAdminGroupsPage from "@/pages/crm/CRMAdminGroupsPage";
import CRMAdminSettingsPage from "@/pages/crm/CRMAdminSettingsPage";

// Service Resources - Specialized Pages
import ConsultantsPage from "@/pages/admin/ConsultantsPage";
import TrainingProgramsPage from "@/pages/admin/TrainingProgramsPage";
import EventsPage from "@/pages/admin/EventsPage";
import WorkspacesPage from "@/pages/admin/WorkspacesPage";
import DigitalServicesPage from "@/pages/admin/DigitalServicesPage";
import BranchServicesPage from "@/pages/admin/BranchServicesPage";

// Locations & Channels
import CitiesPage from "@/pages/admin/CitiesPage";
import BranchesPage from "@/pages/admin/BranchesPage";

function ProtectedRoute({ children }) {
  const token = localStorage.getItem("hala_admin_token");
  return token ? children : <Navigate to="/admin/login" replace />;
}

function CRMProtectedRoute({ children }) {
  const token = localStorage.getItem("crm_token");
  return token ? children : <Navigate to="/crm/login" replace />;
}

function App() {
  return (
    <SiteGate>
      <div className="App">
        <BrowserRouter>
        <Routes>
          {/* Customer-facing Hala */}
          <Route path="/" element={<ChatPage />} />
          <Route path="/financial-advisor" element={<FinancialAdvisorPage />} />
          <Route path="/review-plan" element={<PlanReviewPage />} />
          
          {/* Legacy Admin Login */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin/legacy"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          
          {/* Hala Control Center - Premium Admin Panel */}
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<DashboardPage />} />
            <Route path="catalog" element={<CatalogPageV2 />} />
            <Route path="recommendations" element={<RecommendationEnginePage />} />
            <Route path="resources" element={<ResourcesPage />} />
            <Route path="mapping" element={<MappingPage />} />
            <Route path="sessions" element={<SessionsPageV2 />} />
            <Route path="sessions-old" element={<SessionsPage />} />
            <Route path="session/:sessionId" element={<SessionAnalysisPage />} />
            <Route path="learning-center" element={<LearningCenterPage />} />
            <Route path="ai-analytics" element={<AIAnalyticsPage />} />
            <Route path="financial-settings" element={<FinancialAdvisorSettingsPage />} />
            <Route path="leads" element={<LeadsPage />} />
            <Route path="issues" element={<IssuesPage />} />
            <Route path="analytics" element={<AnalyticsPage />} />
            <Route path="users" element={<UsersPage />} />
            
            {/* CRM - Administrative Structure */}
            <Route path="crm/users" element={<CRMUsersPage />} />
            <Route path="crm/groups" element={<CRMGroupsPage />} />
            <Route path="crm/roles" element={<CRMRolesPage />} />
            
            {/* Service Resources - Specialized Pages */}
            <Route path="consultants" element={<ConsultantsPage />} />
            <Route path="training-programs" element={<TrainingProgramsPage />} />
            <Route path="events" element={<EventsPage />} />
            <Route path="workspaces" element={<WorkspacesPage />} />
            <Route path="digital-services" element={<DigitalServicesPage />} />
            <Route path="branch-services" element={<BranchServicesPage />} />
            
            {/* Locations & Channels */}
            <Route path="cities" element={<CitiesPage />} />
            <Route path="branches" element={<BranchesPage />} />
          </Route>
          
          {/* CRM - Operational Portal */}
          <Route path="/crm/login" element={<CRMLoginPage />} />
          <Route
            path="/crm"
            element={
              <CRMProtectedRoute>
                <CRMLayout />
              </CRMProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/crm/dashboard" replace />} />
            <Route path="dashboard" element={<CRMDashboardPage />} />
            <Route path="supervisor" element={<CRMSupervisorPage />} />
            <Route path="requests" element={<CRMRequestsPage />} />
            <Route path="pool" element={<CRMPoolPage />} />
            <Route path="my-requests" element={<CRMMyRequestsPage />} />
            <Route path="request/:requestId" element={<CRMRequestDetailsPage />} />
            <Route path="users" element={<CRMAdminUsersPage />} />
            <Route path="groups" element={<CRMAdminGroupsPage />} />
            <Route path="settings" element={<CRMAdminSettingsPage />} />
          </Route>
          
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
    </SiteGate>
  );
}

export default App;
